module.exports = __webpack_public_path__ + "static/media/GoaChannelPartner.ea814b28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/ThreeHundred/GoaChannelPartner.jpg
// module id = 832
// module chunks = 11